export const steps = [
  "basic_info",
  "education_level",
  "schedule",
  "sources",
  "materials",
  "structure",
];

export const getSteps = (hasMainNote: boolean) => {
  if (hasMainNote) return steps.filter(step => step !== 'basic_info');
  return steps;
}
